let baseURL;

// baseURL = 'https://qa-publicparkingapp.appinsnap.com/api/';
baseURL = 'https://api.pakparking.com/api/';
export { baseURL };
